
document.addEventListener('DOMContentLoaded', function(e) {
  var hamburger = document.getElementsByClassName('js_hamburger')[0];

  hamburger.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('menu-open');
  });
});
